import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { LoadingService } from '../../../../../shared/services/loading.service';
import { UserService } from '../../../services/user.service';
import { GETSetupEquipmentService } from '../../../setup-equipment/setup-equipment.service';
import { EquipmentInspectionForcastingViewModel } from '../../equipment-details.model';
import { Equipment } from '../../../setup-equipment/setup-equipment.model';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-inspection-planner',
  templateUrl: './inspection-planner.component.html',
  styleUrls: ['./inspection-planner.component.css']
})
export class GETInspectionPlannerComponent implements OnInit {

  equipmentId: number = 0;
  saving: boolean = false;
  _isLoading: boolean = false;
  equipment: Equipment = new Equipment();
  labelPosition = 'before';
  unitList = [
      { Id: 0, Name: 'Hours' },
      { Id: 1, Name: 'Days' },
      { Id: 2, Name: 'Weeks' },
      { Id: 3, Name: 'Months' }
  ]
  unitPeriodicList = [
      { Id: 4, Name: 'Weekly' },
      { Id: 5, Name: 'Monthly' },
      { Id: 6, Name: 'Quarterly' },
      { Id: 7, Name: 'Yearly' }
  ]
  constructor(private _loading: LoadingService,
      private _user: UserService,
      public dialogRef: MatDialogRef<GETInspectionPlannerComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private _setupService: GETSetupEquipmentService,
      public toastr: NotificationsService, vRef: ViewContainerRef,
     
  ) { }

  ngOnInit() {
      this.equipmentId = this.data.equipmentId;
      if (this.equipmentId) {
          this._isLoading = true;
          this._setupService.getEquipmentSetupDetails(this.equipmentId).subscribe(result => {
              console.log('getEquipmentSetupDetails result', result);
              this.equipment = result;
          }, error => console.error(error), () => { this._isLoading = false; });
      }
  }

  updateInspectionPlanner() {
      this.saving = true;
      // this._setupService.updateInspectionPlanner(this.equipment).subscribe(result => {
      //     if (result.m_Item1 > 0) {
      //         this._notification.success('Success', result.m_Item2);
      //         this.dialogRef.close(true);
      //     }
      //     else this._notification.warn('Failed', result.m_Item2);
      // }, error => console.error(error), () => { this.saving = false; });

      let model = new EquipmentInspectionForcastingViewModel();
      model.Id = this.equipmentId;
      model.JobsiteId = this.equipment.JobsiteId;
      model.CreatedByUserId = this.equipment.CreatedByUserId;
      model.EnableAutoInspectionPlanner = this.equipment.EnableAutoInspectionPlanner;
      model.UsedMonday = this.equipment.UsedMonday;
      model.UsedTuesday = this.equipment.UsedTuesday;
      model.UsedWednesday = this.equipment.UsedWednesday;
      model.UsedThursday = this.equipment.UsedThursday;
      model.UsedFriday = this.equipment.UsedFriday;
      model.UsedSaturday = this.equipment.UsedSaturday;
      model.UsedSunday = this.equipment.UsedSunday;
      model.InspectEvery = this.equipment.InspectEvery;
      model.InspectEveryUnitTypeId = this.equipment.InspectEveryUnitTypeId;
      model.HoursOfUsePerDay = this.equipment.HoursOfUsePerDay;

       this._setupService.updateInspectionForecast(model).subscribe(result => {
          if (result.m_Item1 > 0) {
              this.toastr.success('Success', result.m_Item2);
              this.dialogRef.close(true);
          }
          else this.toastr.warn('Failed', result.m_Item2);
      }, error => console.error(error), () => { this.saving = false; });



  }

  onNoClick(): void {
      this.dialogRef.close(false);
  }
}


